import clsx from 'clsx';

import { Types, Text, Icon, baseVariables } from '@marriott/mi-ui-library';
import { convertToCommaSeparatedNumber, useMediaQuery } from '@marriott/shared/mi-helper-utils';
import { IMerchandisingHeroBannerVariations } from '../organisms/MerchandisingHeroBanner/MerchandisingHeroBanner.types';
import { CoBrandWrapper } from '../organisms/MerchandisingHeroBanner/MerchandisingHeroBanner.styles';
import { updateClass } from '../utils/helpers';

export const MerchandisingHeroBannerVariations = (props: IMerchandisingHeroBannerVariations) => {
  const {
    dataLayer,
    mathLabel1,
    mathLabel2,
    mathLabel3,
    mathValue,
    mathType,
    isLightScrim,
    isMerchHero3X1 = false,
    heroSize,
    isHomepage = false,
  } = props;
  const { size, tags, ImageAspectRatio } = Types;
  const { SIZE_2X1 } = ImageAspectRatio;
  const balancePoints = parseInt(`${dataLayer?.['mr_prof_points_balance'] ?? '0'}`, 10);
  const bonusPoint = mathValue ? parseInt(mathValue.replace(/,/g, ''), 10) : 0;
  const totalPoints: number = balancePoints + bonusPoint;

  const cobrandLabelClassName = clsx(
    isLightScrim
      ? updateClass('t-overline-normal t-color-black', 'herobanner3X1__cobrand-black', isMerchHero3X1)
      : updateClass('t-overline-inverse-normal', 'herobanner3X1__cobrand-white', isMerchHero3X1),
    isMerchHero3X1 ? '' : 'hb__cobrand-label'
  );
  const cobrandBalanceClassName = clsx(
    isLightScrim
      ? updateClass('t-overline-normal t-color-black', 'herobanner3X1__cobrand-black', isMerchHero3X1)
      : updateClass('t-overline-inverse-normal', 'herobanner3X1__cobrand-white', isMerchHero3X1),
    isMerchHero3X1 ? 't-numbers-s' : 'hb__cobrand-balance-points'
  );
  const cobrandBonusClassName = clsx(
    isLightScrim
      ? updateClass('t-overline-normal t-color-black', 'herobanner3X1__cobrand-black', isMerchHero3X1)
      : updateClass('t-overline-inverse-normal', 'herobanner3X1__cobrand-white', isMerchHero3X1),
    isMerchHero3X1 ? 't-numbers-s' : 'hb__cobrand-bonus-points'
  );
  const cobrandTotalClassName = clsx(
    isLightScrim
      ? updateClass('t-overline-normal t-color-black', 'herobanner3X1__cobrand-black', isMerchHero3X1)
      : updateClass('t-overline-inverse-normal', 'herobanner3X1__cobrand-white', isMerchHero3X1),
    isMerchHero3X1 ? 't-numbers-s' : 'hb__cobrand-total-points'
  );

  const isPointsVariation = mathType?.toLowerCase() === 'points';
  const isNightsVariation = mathType?.toLowerCase() === 'nights';
  const yourBalance = parseInt(`${dataLayer?.['mr_prof_nights_booked_this_year'] ?? '0'}`, 10);
  const totalBalance = yourBalance + bonusPoint;

  const isDesktopViewPort = useMediaQuery(baseVariables.mediaQuery.xl);
  const isHomepageHero2x1 = isHomepage && heroSize === SIZE_2X1;

  return (
    <CoBrandWrapper className={clsx('row', { 'd-md-block d-xl-flex mx-md-0 mx-xl-n2': isHomepageHero2x1 })}>
      {' '}
      <div
        className={clsx(
          isHomepageHero2x1 ? 'px-md-0 px-xl-2.5' : '',
          updateClass(
            'col-lg-7 hb__cobrand hb__original',
            'mb-0 herobanner3X1__cobrand variation-3X1 p-0 pl-2 mt-xl-0 mb-xl-2',
            isMerchHero3X1,
          ),
          {
            'nightsVariation ': isNightsVariation,
          },
        )}
      >
        <div className={isMerchHero3X1 ? 'herobanner3X1__cobrand-balance d-inline-block' : 'hb__cobrand-balance'}>
          <Text
            copyText={mathLabel1 ?? ''}
            customClass={cobrandLabelClassName}
            fontSize={isMerchHero3X1 ? (isDesktopViewPort ? size.extraSmall : size.small) : size.small}
            element={tags.div}
          />
          <div className={isMerchHero3X1 ? 'd-inline-block mt-2 mt-xl-1' : ''}>
            <Text
              copyText={
                isPointsVariation
                  ? convertToCommaSeparatedNumber(balancePoints)
                  : convertToCommaSeparatedNumber(yourBalance)
              }
              customClass={cobrandBalanceClassName}
              fontSize={size.small}
              element={tags.div}
            />
          </div>
        </div>
        <Icon
          iconClass={clsx(
            updateClass(
              'icon-plus',
              'icon-plus d-inline-block my-0 mx-1 mx-md-3 d-md-flex align-items-md-end justify-content-md-center',
              isMerchHero3X1,
            ),
            isMerchHero3X1 ? 'variation-3X1 t-numbers-s' : '',
            isMerchHero3X1 && isLightScrim ? 'herobanner3X1__icon-black' : '',
          )}
        ></Icon>
        <div className={isMerchHero3X1 ? 'd-inline-block herobanner3X1__cobrand-bonus' : 'hb__cobrand-bonus'}>
          <Text
            copyText={mathLabel2 ?? ''}
            customClass={cobrandLabelClassName}
            fontSize={isMerchHero3X1 ? (isDesktopViewPort ? size.extraSmall : size.small) : size.small}
            element={tags.div}
          />
          <div className={isMerchHero3X1 ? 'd-inline-block mt-2 mt-xl-1' : ''}>
            <Text
              copyText={convertToCommaSeparatedNumber(bonusPoint) ?? '0'}
              customClass={cobrandBonusClassName}
              fontSize={size.small}
              element={tags.div}
            />
          </div>
        </div>
        <div
          className={clsx(
            updateClass(
              'equal-icon',
              'equal-icon d-none my-0 mx-1 mx-md-3 d-md-flex align-items-md-end justify-content-md-center',
              isMerchHero3X1,
            ),
            isMerchHero3X1 ? 'variation-3X1 t-numbers-s' : '',
            isMerchHero3X1 && isLightScrim ? 'herobanner3X1__icon-black' : '',
            isPointsVariation ? updateClass('d-sm-flex d-none', 'd-none d-md-flex', isMerchHero3X1) : '',
            {
              'd-none d-md-flex': isNightsVariation,
            },
          )}
        >
          =
        </div>
        <div
          className={clsx(
            updateClass(
              'hb__cobrand-total',
              'herobanner3X1__cobrand-total d-flex align-items-start flex-column mt-2 d-md-inline-block mt-md-0 pt-md-0 align-items-start',
              isMerchHero3X1,
            ),
            {
              // note: this will work only on small screens, becoz for mobile & desktop display set to block in css file
              'flex-column-reverse align-items-start': isNightsVariation,
              'flex-column': isMerchHero3X1,
            },
          )}
        >
          <Text
            copyText={mathLabel3 ?? ''}
            customClass={clsx(cobrandLabelClassName, isMerchHero3X1 ? 'mt-2 mt-md-0' : '')}
            fontSize={isMerchHero3X1 ? (isDesktopViewPort ? size.extraSmall : size.small) : size.small}
            element={tags.div}
          />
          <div
            className={
              isMerchHero3X1
                ? 'herobanner3X1__cobrand-total__points-wrapper mr-0 d-inline-block mt-2 mt-xl-1'
                : 'hb__cobrand-total__points-wrapper'
            }
          >
            <Text
              copyText={
                isPointsVariation
                  ? convertToCommaSeparatedNumber(totalPoints)
                  : convertToCommaSeparatedNumber(totalBalance)
              }
              customClass={cobrandTotalClassName}
              fontSize={size.small}
              element={tags.div}
            />
          </div>
        </div>
      </div>
    </CoBrandWrapper>
  );
};
